import {createEntitySlice} from 'utils/createEntitySlice';
import {DocumentTemplateElement} from 'types/documentTemplateElement';
import {DocumentTemplateElementThunks} from 'features/programs/program/documentTemplateElement/documentTemplateElementThunks';

export interface DocumentTemplateElementState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  documentTemplateElements?: any;
  pagy?: any;
  documentTemplateElement?: any;
  isEditing?: boolean;
}

const initialState: DocumentTemplateElementState = {
  status: 'idle',
  error: null,
  documentTemplateElements: [],
  documentTemplateElement: {
    name: '',
    conversionType: '',
    aggregation: '',
    period: '',
  },
  pagy: {},
  isEditing: false,
};

const documentTemplateElementSlice = createEntitySlice<DocumentTemplateElement>(
  {
    name: 'Custom Data',
    initialState,
    thunks: DocumentTemplateElementThunks,
    entityKey: 'documentTemplateElement',
    entitiesKey: 'documentTemplateElements',
    reducers: {},
  },
);

export const {setEntity: setDocumentTemplateElement, setIsEditing} =
  documentTemplateElementSlice.actions;
export {initialState as documentTemplateElementInitialState};
export default documentTemplateElementSlice.reducer;
